'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var styled = require('styled-components');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
var button = require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
var fontIcon = require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
var headings = require('../../../../enums/headings.js');
require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
require('../../../../themes/alert.js');
var borders = require('../../../../themes/borders.js');
require('../../../../themes/button.js');
require('../../../../themes/checkbox.js');
require('../../../../themes/divider.js');
require('../../../../themes/dropdown.js');
require('../../../../themes/fieldset.js');
require('../../../../themes/input.js');
require('../../../../themes/list.js');
require('../../../../themes/listbox.js');
require('../../../../themes/loader.js');
require('../../../../themes/option.js');
require('../../../../themes/popout.js');
require('../../../../themes/switch.js');
var themes = require('../../../../themes/themes.js');
require('../../../../themes/tooltip.js');
var color = require('../../../../utilities/color.js');
require('date-fns');
require('../../../../utilities/locale.js');
require('../../../atoms/icon/font-icon/font-icon.js');
require('react-transition-group');
require('../../../atoms/alert/inline-alert/inline-alert.js');
require('../../../atoms/alert/standard-alert/standard-alert.js');
require('boring-avatars');
require('../../../atoms/tooltip/hover-tooltip/hover-tooltip.js');
require('react-laag');
require('../../../../styles/styled-components/alert.js');
require('../../../../styles/styled-components/animations.js');
require('../../../../styles/styled-components/box-shadow.js');
require('../../../../styles/styled-components/button.js');
require('../../../../styles/styled-components/font-face.js');
require('../../../../styles/styled-components/global.js');
require('../../../../styles/styled-components/input.js');
require('../../../../styles/styled-components/list.js');
require('../../../../styles/styled-components/listitem.js');
require('../../../../styles/styled-components/media-queries.js');
require('../../../../styles/styled-components/reset.js');
require('../../../../styles/styled-components/outline.js');
require('../../../../styles/styled-components/popout.js');
require('../../../../styles/styled-components/screen-reader.js');
require('../../../../styles/styled-components/switch.js');
require('../../../../styles/styled-components/tooltip.js');
require('@brandfolder/utilities');
require('../../../atoms/button/close-button/close-button.js');
require('../../../atoms/button/color-button/color-button.js');
var copyButton = require('../../../atoms/button/copy-button/copy-button.js');
var iconButton = require('../../../atoms/button/icon-button/icon-button.js');
require('../../../atoms/button/standard-button/standard-button.js');
require('../../../atoms/loader/circle-loader/circle-loader.js');
require('../../../atoms/loader/shimmer-loader/shimmer-loader.js');
require('../../../atoms/divider/standard-divider/standard-divider.js');
require('../../../atoms/fieldset/standard-fieldset/standard-fieldset.js');
var standardHeading = require('../../../atoms/heading/standard-heading/standard-heading.js');
require('../../../atoms/label/standard-label/standard-label.js');
require('../../../atoms/link/button-link/button-link.js');
require('../../../atoms/link/standard-link/standard-link.js');
require('../../../atoms/popout/standard-popout/standard-popout.js');
require('../../../atoms/screen-reader/only-for-screen-reader/only-for-screen-reader.js');
require('../../../atoms/table/standard-table/caption.js');
require('../../../atoms/table/standard-table/tbody.js');
require('../../../atoms/table/standard-table/tr-empty.js');
require('../../../atoms/table/standard-table/td.js');
require('../../../atoms/table/standard-table/tr.js');
require('../../../atoms/table/standard-table/table.js');
require('../../../atoms/table/standard-table/tfoot.js');
require('../../../atoms/table/standard-table/th.js');
require('../../../atoms/table/standard-table/thead.js');
require('../../../atoms/table/dnd-table/dnd-handle-td.js');
require('../../../atoms/table/dnd-table/dnd-table-drag-context.js');
require('../../../../hooks/use-prevent-keyboard-scrolling.js');
require('../../../atoms/text/help-text/help-text.js');
var standardText = require('../../../atoms/text/standard-text/standard-text.js');
var baseColorSwatch = require('../base-color-swatch/base-color-swatch.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const BaseStandardColorSwatch = (props)=>{
    const { className , colors ={} , emptyText ='- - -' , headingProps , id , labels , name , showCmyk , showCopy , showEmptyCmyk , showEmptyHex , showEmptyHsl , showEmptyRgb , showHex , showHsl , showName , showRgb , textProps , ...otherProps } = props;
    const { cmyk , hex , hsl , rgb  } = colors;
    const { copiedLabel , copyLabel  } = labels;
    const cmykString = color.convertCmykToString(cmyk);
    const hexString = color.convertHexToString(hex);
    const hslString = color.convertHslToString(hsl);
    const rgbString = color.convertRgbToString(rgb);
    const hasCmyk = !!cmykString && showCmyk;
    const hasHex = !!hexString && showHex;
    const hasHsl = !!hslString && showHsl;
    const hasName = !!name && showName;
    const hasRgb = !!rgbString && showRgb;
    const cmykId = `${id}-cmyk-tooltip`;
    const hexId = `${id}-hex-tooltip`;
    const hslId = `${id}-hsl-tooltip`;
    const rgbId = `${id}-rgb-tooltip`;
    return /*#__PURE__*/ React__default.default.createElement(baseColorSwatch.BaseColorSwatch, _extends({}, otherProps, {
        className: classnames__default.default({
            'bf-color-swatch__standard': true,
            'bf-color-swatch__standard--has-name': hasName,
            'bf-color-swatch__standard--has-cmyk': hasCmyk,
            'bf-color-swatch__standard--has-hex': hasHex,
            'bf-color-swatch__standard--has-hsl': hasHsl,
            'bf-color-swatch__standard--has-rgb': hasRgb,
            'bf-color-swatch__standard--has-all-colors': hasCmyk && hasHex && hasHsl && hasRgb,
            'bf-color-swatch__standard--has-no-colors': !hasCmyk && !hasHex && !hasHsl && !hasRgb,
            'bf-color-swatch__standard--show-empty-cmyk': showEmptyCmyk,
            'bf-color-swatch__standard--show-empty-hex': showEmptyHex,
            'bf-color-swatch__standard--show-empty-hsl': showEmptyHsl,
            'bf-color-swatch__standard--show-empty-rgb': showEmptyRgb,
            [`${className}`]: !!className
        })
    }), hasName && /*#__PURE__*/ React__default.default.createElement(standardHeading.StandardHeading, _extends({}, headingProps, {
        className: classnames__default.default({
            'bf-color-swatch__text': true,
            'bf-color-swatch__name': true,
            [`${headingProps?.className}`]: !!headingProps?.className
        }),
        level: headingProps?.level || headings.HeadingLevels.h5
    }), name), (hasHex || showEmptyHex) && /*#__PURE__*/ React__default.default.createElement(standardText.StandardText, _extends({}, textProps, {
        "aria-hidden": showEmptyHex || undefined,
        className: classnames__default.default({
            'bf-color-swatch__text': true,
            'bf-color-swatch__color': true,
            'bf-color-swatch__hex': true,
            'bf-color-swatch__empty-hex': showEmptyHex,
            [`${textProps?.className}`]: !!textProps?.className
        })
    }), hexString || emptyText, hasHex && showCopy && /*#__PURE__*/ React__default.default.createElement(copyButton.CopyButton, {
        data: hexString,
        id: hexId,
        tooltip: copiedLabel
    }, /*#__PURE__*/ React__default.default.createElement(iconButton.IconButton, {
        icon: fontIcon.FontIcons.Copy,
        label: copyLabel,
        look: button.ButtonLooks.Default
    }))), (hasHsl || showEmptyHsl) && /*#__PURE__*/ React__default.default.createElement(standardText.StandardText, _extends({}, textProps, {
        "aria-hidden": showEmptyHsl || undefined,
        className: classnames__default.default({
            'bf-color-swatch__text': true,
            'bf-color-swatch__color': true,
            'bf-color-swatch__hsl': true,
            'bf-color-swatch__empty-hsl': showEmptyHsl,
            [`${textProps?.className}`]: !!textProps?.className
        })
    }), hslString || emptyText, hasHsl && showCopy && /*#__PURE__*/ React__default.default.createElement(copyButton.CopyButton, {
        data: hslString,
        id: hslId,
        tooltip: copiedLabel
    }, /*#__PURE__*/ React__default.default.createElement(iconButton.IconButton, {
        icon: fontIcon.FontIcons.Copy,
        label: copyLabel,
        look: button.ButtonLooks.Default
    }))), (hasRgb || showEmptyRgb) && /*#__PURE__*/ React__default.default.createElement(standardText.StandardText, _extends({}, textProps, {
        "aria-hidden": showEmptyRgb || undefined,
        className: classnames__default.default({
            'bf-color-swatch__text': true,
            'bf-color-swatch__color': true,
            'bf-color-swatch__rgb': true,
            'bf-color-swatch__empty-rgb': showEmptyRgb,
            [`${textProps?.className}`]: !!textProps?.className
        })
    }), rgbString || emptyText, hasRgb && showCopy && /*#__PURE__*/ React__default.default.createElement(copyButton.CopyButton, {
        data: rgbString,
        id: rgbId,
        tooltip: copiedLabel
    }, /*#__PURE__*/ React__default.default.createElement(iconButton.IconButton, {
        icon: fontIcon.FontIcons.Copy,
        label: copyLabel,
        look: button.ButtonLooks.Default
    }))), (hasCmyk || showEmptyCmyk) && /*#__PURE__*/ React__default.default.createElement(standardText.StandardText, _extends({}, textProps, {
        "aria-hidden": showEmptyCmyk || undefined,
        className: classnames__default.default({
            'bf-color-swatch__text': true,
            'bf-color-swatch__color': true,
            'bf-color-swatch__cmyk': true,
            'bf-color-swatch__empty-cmyk': showEmptyCmyk,
            [`${textProps?.className}`]: !!textProps?.className
        })
    }), cmykString || emptyText, hasCmyk && showCopy && /*#__PURE__*/ React__default.default.createElement(copyButton.CopyButton, {
        data: cmykString,
        id: cmykId,
        tooltip: copiedLabel
    }, /*#__PURE__*/ React__default.default.createElement(iconButton.IconButton, {
        icon: fontIcon.FontIcons.Copy,
        label: copyLabel,
        look: button.ButtonLooks.Default
    }))));
};
const getBackgroundColors = (options)=>{
    const { colors ={}  } = options;
    const { cmyk , hex , hsl , rgb  } = colors;
    const hexBackgroundColor = hex ? styled.css`
        background-color: ${color.convertHexToString(hex)};
      ` : styled.css``;
    const hslBackgroundColor = hsl ? styled.css`
        background-color: ${color.convertHslToString(hsl)};
      ` : styled.css``;
    const rgbBackgroundColor = rgb ? styled.css`
        background-color: ${color.convertRgbToString(rgb)};
      ` : styled.css``;
    /** Only bother with CMYK to HEX if no other colors are provided */ const cmykBackgroundColor = cmyk && !hex && !hsl && !rgb ? styled.css`
          background-color: ${color.convertCmykToHex(cmyk)};
        ` : styled.css``;
    return styled.css`
    ${hslBackgroundColor}
    ${cmykBackgroundColor}
    ${rgbBackgroundColor}
    ${hexBackgroundColor} // prioritize HEX rendering
  `;
};
const ColorSwatch = styled__default.default(BaseStandardColorSwatch)`
  .bf-color-swatch__swatch {
    aspect-ratio: 1;
    ${({ colors  })=>getBackgroundColors({
        colors
    })}
    border-radius: ${borders.borderRadiusMedium}px;
    display: block;
    margin-bottom: 5px;
    min-width: 80px;

    &:only-child {
      margin-bottom: 0;
    }
  }

  .bf-color-swatch__text {
    margin-top: 1px;
    text-align: center;
  }

  .bf-button__icon {
    border: 0;
    margin-left: 5px;
    min-height: 0;
    padding: 2px;

    .bf-button__font-icon {
      font-size: 12px;
    }
  }
`;
const StandardColorSwatch = (props)=>{
    const { showCmyk =true , showCopy =true , showEmptyCmyk =false , showEmptyHex =false , showEmptyHsl =false , showEmptyRgb =false , showHex =true , showHsl =true , showName =true , showRgb =true , ...otherProps } = props;
    const themeContext = React.useContext(styled.ThemeContext);
    return /*#__PURE__*/ React__default.default.createElement(styled.ThemeProvider, {
        theme: themeContext || themes.lightTheme
    }, /*#__PURE__*/ React__default.default.createElement(ColorSwatch, _extends({}, otherProps, {
        showCmyk: showCmyk,
        showCopy: showCopy,
        showEmptyCmyk: showEmptyCmyk,
        showEmptyHex: showEmptyHex,
        showEmptyHsl: showEmptyHsl,
        showEmptyRgb: showEmptyRgb,
        showHex: showHex,
        showHsl: showHsl,
        showName: showName,
        showRgb: showRgb
    })));
};

exports.BaseStandardColorSwatch = BaseStandardColorSwatch;
exports.StandardColorSwatch = StandardColorSwatch;
//# sourceMappingURL=standard-color-swatch.js.map
